"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _stickyFooter = _interopRequireDefault(require("./sticky-footer.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SCROLL_THROTTLE = 50;

const StickyFooter = ({
  children,
  containerRef,
  disableSticky,
  ...rest
}) => {
  const [isSticky, setIsSticky] = (0, _react.useState)(true);
  const footerRef = (0, _react.useRef)();
  const checkFooterPosition = (0, _react.useCallback)((0, _throttle.default)(() => {
    const content = containerRef.current;
    const stickyOffset = footerRef.current.clientHeight / 2;
    const fullyScrolled = content.scrollHeight - content.scrollTop - stickyOffset <= content.clientHeight;
    setIsSticky(!fullyScrolled);
  }, SCROLL_THROTTLE), []);
  (0, _react.useEffect)(() => {
    const content = containerRef.current;
    content.addEventListener("scroll", checkFooterPosition, false);
    return () => {
      content.removeEventListener("scroll", checkFooterPosition, false);
    };
  }, [checkFooterPosition, containerRef]);
  return /*#__PURE__*/_react.default.createElement(_stickyFooter.default, _extends({
    "data-component": "sticky-footer",
    sticky: disableSticky ? false : isSticky,
    ref: footerRef
  }, rest), children);
};

StickyFooter.propTypes = {
  /** child elements */
  children: _propTypes.default.node.isRequired,

  /** Ref of the container the footer should be sticky on */
  containerRef: _propTypes.default.any.isRequired,

  /** Disable the sticky behaviour manually */
  disableSticky: _propTypes.default.bool
};
var _default = StickyFooter;
exports.default = _default;